import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { EvsUserService } from '../../../../../../common/services/EvsUser.service';
import { CustomerService } from '../../../../qrcode/customer/customer.service';
import { EvsAddressService } from '../../../../../../common/services/EvsAddress.service';
import { ToastrService } from 'ngx-toastr';
import { ConfirmationService, Message } from 'primeng/primeng';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs/Subscription';
declare var $: any;
@Component({
  selector: 'app-customer-manager',
  templateUrl: './customer-manager.component.html',
  styleUrls: ['./customer-manager.component.css'],
  providers: [EvsUserService, CustomerService, EvsAddressService, ConfirmationService]
})
export class CustomerManagerComponent implements OnInit, OnDestroy {

  constructor(
    private evsUserService: EvsUserService,
    private customerService: CustomerService,
    private toastr: ToastrService,
    public addressService: EvsAddressService,
    private confirmationService: ConfirmationService,
    private translate: TranslateService,
  ) { }
  @Input('user') user: any;

  public cities: Array<any> = [];
  customer: any = {};
  listCustomer: any = []
  waitTime: number = 200;
  customerFocus: boolean = false;

  customers: any = [];
  areas: any = []
  page_size: number = 10;
  customerOffset: number = 0;
  areaOffset: number = 0;
  customerCurrentPage: number = 1;
  areaCurrentPage: number = 1;
  private langSub: Subscription;

  ngOnInit() {
    this.initSelect2();
    this.langSub = this.translate.onLangChange.subscribe(() => {
      this.initSelect2();
    });
    this.getCity();
    this.getData();
  }

  ngOnDestroy() {
    if (this.langSub) {
      this.langSub.unsubscribe();
    }
  }

  initSelect2() {
    let province = $('#province');
    province.select2({ placeholder: this.translate.instant('TINH_TP'), allowClear: false, width: '100%' });
  }
  getCity() {
    this.addressService.getCities().subscribe(res => {
      let citiesList = [];
      res.data.cities.forEach((c: any) => {
        citiesList.push({
          value: c.name,
          label: c.name,
          id: c.id,
        });
      });
      this.cities = citiesList;
    });
  }
  getData() {
    let request: any = {};
    request.offset = this.page_size * (this.customerCurrentPage <= 0 ? 0 : this.customerCurrentPage - 1);
    request.limit = this.page_size;
    request.type = 'customer'
    this.evsUserService.getMaganerPermission(this.user.id, request)
      .subscribe(res => {
        if (!res.error) {
          this.customers = res.data.customer.customers;
          this.areas = res.data.customer.cities;
        }
      })
  }
  searchCustomer() {
    let start = new Date().getTime();
    if (this.customer.name) {
      let request: any = {
        limit: 100,
        offset: 0,
        user: this.customer.name
      }
      this.customerService.ListCustomer(request)
        .subscribe(res => {
          if (!res.error) {
            if (res.data.customers) {
              this.listCustomer = res.data.customers;
            } else this.listCustomer = [];
            let stop = new Date().getTime();
            this.waitTime = (stop - start) + 200;
            // setTimeout(() => {
            //   console.log($('typeahead-container'))
            //   $('typeahead-container').css({ "overflow-y": "auto", "height": "200px" });
            // }, this.waitTime)
          }
        })
    }

  }
  focusoutCustomer() {
    setTimeout(() => {
      this.customerFocus = false;
    }, 200)
  }
  addCustomer() {
    if (this.customer.id) {
      let data: any = {
        customer: {
          id: this.customer.id
        }
      };
      this.evsUserService.postMaganerPermission(this.user.id, data)
        .subscribe(res => {
          if (!res.error) {
            this.toastr.success(this.translate.instant('THEM_QUYEN_KHACH_HANG_THANH_CONG'));
            this.customerPage();
          }
        })
    }
  }
  addArea() {
    if ($('#province').val()) {
      let city = parseInt($('#province').val());
      let data: any = {
        customer: {
          city: city
        }
      };
      this.evsUserService.postMaganerPermission(this.user.id, data)
        .subscribe(res => {
          if (!res.error) {
            this.toastr.success(this.translate.instant('THEM_QUYEN_KHU_VUC_THANH_CONG'));
            this.areaPage();
          }
        })
    }
  }
  customerPage() {
    let request: any = {};
    request.offset = this.page_size * (this.customerCurrentPage <= 0 ? 0 : this.customerCurrentPage - 1);
    this.customerOffset = request.offset;
    request.limit = this.page_size;
    request.type = 'customer'
    this.evsUserService.getMaganerPermission(this.user.id, request)
      .subscribe(res => {
        if (!res.error) {
          this.customers = res.data.customer.customers;
          if (this.customerCurrentPage > 1 && !this.customers) {
            this.customerCurrentPage--;
            this.customerPage();
            this.toastr.warning(this.translate.instant('BAN_DANG_O_TRANG_CUOI_CUNG'));
          }
        }
      })
  }
  areaPage() {
    let request: any = {};
    request.offset = this.page_size * (this.areaCurrentPage <= 0 ? 0 : this.areaCurrentPage - 1);
    this.areaOffset = request.offset;
    request.limit = this.page_size;
    request.type = 'customer'
    this.evsUserService.getMaganerPermission(this.user.id, request)
      .subscribe(res => {
        if (!res.error) {
          this.areas = res.data.customer.cities;
          if (this.areaCurrentPage > 1 && (!this.areas || this.areas.length == 0)) {
            this.areaCurrentPage--;
            this.areaPage();
            this.toastr.warning(this.translate.instant('BAN_DANG_O_TRANG_CUOI_CUNG'));
          }
        }
      })
  }





  _keyPress(event: any) {
    if (event.charCode !== 0) {
      const pattern = /[0-9]/;
      const inputChar = String.fromCharCode(event.charCode);

      if (!pattern.test(inputChar)) {
        // invalid character, prevent input
        event.preventDefault();
      }
    }
  }
  deleteCustomer(customer) {
    this.confirmationService.confirm({
      message: this.translate.instant('XAC_NHAN_XOA_QUYEN_KHACH_HANG'),
      header: this.translate.instant('XAC_NHAN'),
      icon: 'fa fa-trash',
      accept: () => {
        if (customer.id) {
          let data: any = {
            customer: {
              id: customer.id
            }
          };
          this.evsUserService.deleteMaganerPermission(this.user.id, data)
            .subscribe(res => {
              if (!res.error) {
                this.toastr.info(this.translate.instant('BAN_VUA_XOA_QUYEN_KHACH_HANG') + ' ' + customer.name);
                this.customerPage();
              }
            })
        }

      }
    });
  }
  deleteArea(area) {
    this.confirmationService.confirm({
      message: this.translate.instant('XAC_NHAN_XOA_QUYEN_KHU_VUC'),
      header: this.translate.instant('XAC_NHAN'),
      icon: 'fa fa-trash',
      accept: () => {
        if (area.id) {
          let data: any = {
            customer: {
              city: area.id
            }
          };
          this.evsUserService.deleteMaganerPermission(this.user.id, data)
            .subscribe(res => {
              if (!res.error) {
                this.toastr.info(this.translate.instant('BAN_VUA_XOA_QUYEN_KHU_VUC') + ' ' + area.name);
                this.areaPage();
              }
            })
        }

      }
    });
  }
}



// WEBPACK FOOTER //
// /app/src/app/pages/admin/evs/business/modal-manager/customer-manager/customer-manager.component.ts